import { Component, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractDialog, AbstractDialogResultData, AbstractFormDialog, AbstractFormDialogData, FormDialogComponent } from '@next/core-lib/dialog';

import { DecimalPipe } from '@angular/common';
// eslint-disable-next-line max-len
import { MatCell, MatCellDef, MatColumnDef, MatFooterCell, MatFooterCellDef, MatFooterRow, MatFooterRowDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable } from '@angular/material/table';
import { TranslatePipe } from '@next/core-lib/i18n';
import { EnvironmentalImpactReport } from '../../environmental-impact.models';

export interface EnvironmentalImpactReportDialogModel extends AbstractFormDialogData {
  report: EnvironmentalImpactReport;
}

@Component({
  selector: 'app-environmental-impact-report-dialog',
  templateUrl: './environmental-impact-report-dialog.component.html',
  styleUrls: ['./environmental-impact-report-dialog.component.scss'],
  imports: [
    FormDialogComponent,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatFooterCellDef,
    MatFooterCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatFooterRowDef,
    MatFooterRow,
    DecimalPipe,
    TranslatePipe,
  ],
})
export class EnvironmentalImpactReportDialogComponent extends AbstractFormDialog<EnvironmentalImpactReport> {
  data = inject<EnvironmentalImpactReportDialogModel>(MAT_DIALOG_DATA);
  protected mdDialogRef = inject<MatDialogRef<AbstractDialog<EnvironmentalImpactReport>, AbstractDialogResultData<EnvironmentalImpactReport>>>(MatDialogRef);
  private fb = inject(FormBuilder);

  formGroup = this.fb.group({ report: this.data.report });

  displayedColumns = [
    'cropAidName',
    'dosage',
    'activeIngredientAmount',
    'driftReduction',
    'aquaticLife',
    'soilLife',
    'groundwaterWashout',
    'pollinators',
    'combatants',
  ];
  displayedTotalColumns = [
    'totalCaption',
    'total2',
    'totalActiveIngredientAmount',
    'total4',
    'totalAquaticLife',
    'totalSoilLife',
    'totalGroundwaterWashout',
    'total8',
    'total9',
  ];

  hasSuccessBg = (value: number): boolean => value < 100;
  hasAlertBg = (value: number): boolean => value >= 100 && value < 1000;
  hasWarnBg = (value: number): boolean => value >= 1000;
}
